import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { PageLoader } from "../../components/page-loader";

export const CallbackPage: React.FC = () => {
  const { error } = useAuth0();

  if (error) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <h2>Authentication Error</h2>
        <p>{error.message}</p>
        <button
          onClick={() => {
            window.location.href = "/login";
          }}
          style={{
            padding: "10px 20px",
            marginTop: "20px",
            cursor: "pointer",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
          }}
        >
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div>
      <PageLoader />
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        Completing authentication...
      </div>
    </div>
  );
};
